var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _polygon, _path11, _polygon2, _path12, _rect, _rect2, _rect3, _path13, _path14, _path15, _path16, _path17, _circle, _circle2, _path18, _path19, _polygon3, _path20, _polygon4, _path21, _circle3, _path22, _path23, _path24, _ellipse, _path25, _path26, _rect4, _rect5, _path27, _path28, _path29, _path30;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a1e1570b-8396-4618-92f2-a997ce86d02e",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 733.48299,
    height: 545.69099,
    viewBox: "0 0 733.48299 545.69099",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M946.0846,640.86343c-3.31771-26.67813-19.85136-52.96384-45.29423-61.64563a123.86326,123.86326,0,0,1-.00614,85.04047c-3.90959,10.5753-9.35913,21.9305-5.68164,32.5888,2.28808,6.63189,7.88558,11.70586,14.14246,14.87849,6.25726,3.17263,13.20151,4.68476,20.05886,6.16664l1.34956,1.11617C941.53941,694.42737,949.4023,667.54156,946.0846,640.86343Z",
    transform: "translate(-233.2585 -177.1545)",
    fill: "#f0f0f0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M900.53789,579.72224a105.86968,105.86968,0,0,1,26.31905,59.58345,45.59121,45.59121,0,0,1-.51859,14.27515,26.14853,26.14853,0,0,1-6.50348,12.12824c-2.93125,3.22058-6.30256,6.17543-8.3999,10.05247a16.01079,16.01079,0,0,0-.78221,13.07062c1.85173,5.31109,5.5014,9.64009,9.21758,13.74946,4.12611,4.56266,8.48414,9.23647,10.23806,15.28536.21251.7329,1.3373.3603,1.12511-.3715-3.0515-10.524-13.26754-16.50187-18.13955-25.98072-2.27337-4.423-3.22759-9.55792-1.09634-14.22686,1.86369-4.08278,5.3376-7.13282,8.33375-10.36807a27.9024,27.9024,0,0,0,6.80084-11.62187,42.14763,42.14763,0,0,0,1.06551-14.20255,102.7124,102.7124,0,0,0-7.50151-31.21349A107.74708,107.74708,0,0,0,901.3219,578.8336c-.50661-.56729-1.28731.325-.784.88864Z",
    transform: "translate(-233.2585 -177.1545)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M926.538,632.13532a15.88383,15.88383,0,0,0,12.09073-16.6389c-.06037-.75995-1.24413-.70184-1.18368.05912a14.70808,14.70808,0,0,1-11.27854,15.45466c-.74175.17635-.366,1.30046.37149,1.12512Z",
    transform: "translate(-233.2585 -177.1545)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M921.53621,664.27187A30.6148,30.6148,0,0,1,907.86486,646.64c-.2151-.73213-1.34-.35975-1.12512.37149a31.844,31.844,0,0,0,14.26357,18.31865c.657.38974,1.18635-.67064.5329-1.05826Z",
    transform: "translate(-233.2585 -177.1545)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M914.9566,599.62584a8.991,8.991,0,0,1-8.52045-.43252c-.65176-.39787-1.18041.663-.53289,1.05826a10.07516,10.07516,0,0,0,9.42483.49938.61232.61232,0,0,0,.37681-.7483.59542.59542,0,0,0-.7483-.37682Z",
    transform: "translate(-233.2585 -177.1545)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M823.23692,626.86819c.3999.26.7998.52,1.20019.79a118.40706,118.40706,0,0,1,15.13965,11.81995c.37012.33.74024.67,1.1001,1.01a124.82713,124.82713,0,0,1,27.10986,37.11,121.222,121.222,0,0,1,6.64014,17.18c2.45019,8.13,4.46,17.14,9.31006,23.79a20.79775,20.79775,0,0,0,1.62011,2h43.83008c.09961-.05.19971-.09.29981-.14l1.75.08c-.07032-.31-.14991-.63-.22022-.94-.04-.18-.08984-.36-.12988-.54-.02979-.12-.06006-.24-.08008-.35-.00976-.04-.02-.08-.02978-.11-.02-.11-.0503-.21-.07032-.31q-.65991-2.685-1.35986-5.37c0-.01,0-.01-.00977-.02-3.59033-13.63-8.35009-27.08-15-39.38-.20019-.37-.3999-.75-.62011-1.12a115.67433,115.67433,0,0,0-10.39014-15.76,102.25826,102.25826,0,0,0-6.81006-7.79,85.03667,85.03667,0,0,0-21.27978-15.94c-15.72022-8.3-33.91992-11.48-50.72022-6.41C824.087,626.59823,823.6666,626.72817,823.23692,626.86819Z",
    transform: "translate(-233.2585 -177.1545)",
    fill: "#f0f0f0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M823.33545,627.42448a105.86975,105.86975,0,0,1,56.88765,31.72816,45.59117,45.59117,0,0,1,8.18055,11.71015A26.14845,26.14845,0,0,1,890.513,684.462c-.40143,4.33627-1.31421,8.72532-.65458,13.08366a16.01083,16.01083,0,0,0,7.24487,10.9071c4.67615,3.12574,10.19656,4.38485,15.63785,5.42855,6.04151,1.15883,12.33511,2.26677,17.37735,6.04049.61094.45724,1.2847-.51747.67468-.974-8.77264-6.56563-20.52866-5.18785-30.12561-9.82289-4.47811-2.1628-8.33157-5.68824-9.44091-10.69928-.97007-4.38194-.03267-8.90876.41174-13.29582a27.9026,27.9026,0,0,0-1.56708-13.374,42.14786,42.14786,0,0,0-7.70017-11.98145A102.71247,102.71247,0,0,0,857.589,639.36861a107.74717,107.74717,0,0,0-34.16254-13.12569c-.746-.14794-.83214,1.03459-.091,1.18156Z",
    transform: "translate(-233.2585 -177.1545)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M875.65139,653.61952a15.88383,15.88383,0,0,0-.364-20.56468c-.50575-.57044-1.41594.18867-.90952.75986a14.70808,14.70808,0,0,1,.2995,19.13014c-.48607.58739.49072,1.25871.974.67468Z",
    transform: "translate(-233.2585 -177.1545)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M891.00615,682.29019a30.61483,30.61483,0,0,1-21.53141-5.847c-.61254-.45506-1.28648.5195-.67468.974a31.844,31.844,0,0,0,22.41775,6.03876c.75924-.08439.54346-1.24973-.21166-1.1658Z",
    transform: "translate(-233.2585 -177.1545)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M846.83133,634.63534a8.991,8.991,0,0,1-7.06351,4.78455c-.75994.07472-.54333,1.24.21166,1.1658a10.07516,10.07516,0,0,0,7.82586-5.27567.61234.61234,0,0,0-.14966-.82435.59542.59542,0,0,0-.82435.14967Z",
    transform: "translate(-233.2585 -177.1545)",
    fill: "#fff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "121.202 0 484.397 0 484.397 119.231 470.64 119.231 470.64 150.414 439.456 119.231 121.202 119.231 121.202 0",
    fill: "#e4e4e4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M708.06684,284.64974H364.04853V188.265h269.1001a75.00283,75.00283,0,0,1,74.91821,74.918Z",
    transform: "translate(-233.2585 -177.1545)",
    fill: "#fff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "363.195 171.414 0 171.414 0 290.644 13.757 290.644 13.757 321.828 44.941 290.644 363.195 290.644 363.195 171.414",
    fill: "#e4e4e4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M586.86542,456.0638H303.98163a61.20365,61.20365,0,0,1-61.1344-61.13427V359.679H586.86542Z",
    transform: "translate(-233.2585 -177.1545)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.42418,
    y: 211.78996,
    width: 288.37073,
    height: 5.01202,
    fill: "#ff9100"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40.42418,
    y: 229.12813,
    width: 287.85041,
    height: 5.01202,
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40.42418,
    y: 246.46631,
    width: 287.56853,
    height: 5.01202,
    fill: "#e6e6e6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M474.65144,256.29671l-18.26826-18.26826a13.43147,13.43147,0,0,1,18.26826-19.67,13.43168,13.43168,0,0,1,18.26872,19.67Zm-8.771-39.13791a11.37213,11.37213,0,0,0-8.04484,19.41723l16.81587,16.81586L491.4678,236.576a11.37747,11.37747,0,1,0-16.09017-16.09017l-.72616.72616-.72617-.72616a11.34342,11.34342,0,0,0-8.04489-3.327Z",
    transform: "translate(-233.2585 -177.1545)",
    fill: "#ff9100"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M538.33227,226.40868a3.00128,3.00128,0,0,0-4.24477,4.24412l.00031.00031,4.24446,4.24443,4.24447-4.24443a3.00128,3.00128,0,1,0-4.24415-4.24474Z",
    transform: "translate(-233.2585 -177.1545)",
    fill: "#ff9100"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M520.87146,226.40868a3.00128,3.00128,0,0,0-4.24478,4.24412l.00032.00031,4.24446,4.24443,4.24446-4.24443a3.00128,3.00128,0,1,0-4.24415-4.24474Z",
    transform: "translate(-233.2585 -177.1545)",
    fill: "#ff9100"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M529.9933,258.23507a22.59635,22.59635,0,1,1,22.59635-22.59635h0A22.6219,22.6219,0,0,1,529.9933,258.23507Zm0-43.13848a20.54214,20.54214,0,1,0,20.54213,20.54213A20.54212,20.54212,0,0,0,529.9933,215.09659Z",
    transform: "translate(-233.2585 -177.1545)",
    fill: "#ff9100"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M585.45706,258.23507a22.59635,22.59635,0,1,1,22.59635-22.59635h0A22.62188,22.62188,0,0,1,585.45706,258.23507Zm0-43.13848a20.54214,20.54214,0,1,0,20.54214,20.54213A20.54212,20.54212,0,0,0,585.45706,215.09659Z",
    transform: "translate(-233.2585 -177.1545)",
    fill: "#ff9100"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 361.44254,
    cy: 51.29447,
    r: 5.13553,
    fill: "#ff9100"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 343.98172,
    cy: 51.29447,
    r: 5.13553,
    fill: "#ff9100"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M579.05507,239.74715c-2.09552,14.49726,14.53422,17.43787,12.86968-.00059C592.02368,239.73474,579.72516,239.75612,579.05507,239.74715Z",
    transform: "translate(-233.2585 -177.1545)",
    fill: "#ff9100"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M522.07968,242.756c4.69664,6.314,12.81683,6.881,17.15758,0Z",
    transform: "translate(-233.2585 -177.1545)",
    fill: "#ff9100"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "583.591 532.478 571.331 532.478 565.499 485.19 583.593 485.19 583.591 532.478",
    fill: "#9e616a"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M819.97591,721.51666l-39.53077-.00146v-.5A15.3873,15.3873,0,0,1,795.83162,705.629h.001l24.144.001Z",
    transform: "translate(-233.2585 -177.1545)",
    fill: "#2f2e41"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "491.214 532.075 479.406 528.776 486.513 481.663 503.94 486.532 491.214 532.075",
    fill: "#9e616a"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M724.28576,721.51666,686.2134,710.8782l.13454-.48156a15.38729,15.38729,0,0,1,18.95915-10.6785l.00094.00026,23.25328,6.49769Z",
    transform: "translate(-233.2585 -177.1545)",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 554.58724,
    cy: 109.53287,
    r: 26.82091,
    fill: "#9e616a"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M800.54059,420.93667l2.126,14.55524s26.82093,53.31473-2.28961,79.48145c0,0-43.5022,131.18786-55.93139,148.8504L734.05341,685.5682l-20-3,12.4027-74.67584,20.93335-106.65655,3.1073-83.24292S796.28851,414.72207,800.54059,420.93667Z",
    transform: "translate(-233.2585 -177.1545)",
    fill: "#2f2e41"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M795.47082,511.6838l14.71875,83.4336s7.85,38.26886,8.50422,52.98761,3.27081,33.6897,3.27081,33.6897l-26.49384,4.25207L769.304,573.8298Z",
    transform: "translate(-233.2585 -177.1545)",
    fill: "#2f2e41"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M817.05341,348.5682l-1.90522,48.56659L805.0871,419.38958l-3.72876,8.25235-53.96888-.65417,5.56043-37.61469c-7.85-20.27923,10.79376-28.45632,10.79376-28.45632l15.7-16.73038-1.39025-21.61817,23.63195-4.49951c12.2983-2.34158,6.36805,15.49951,6.36805,15.49951C824.40766,331.93279,817.05341,348.5682,817.05341,348.5682Z",
    transform: "translate(-233.2585 -177.1545)",
    fill: "#ff9100"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 707.46603,
    cy: 393.65787,
    rx: 0.63806,
    ry: 1.70151,
    transform: "translate(-236.87008 603.59941) rotate(-57.656)",
    fill: "#3f3d56"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M706.11657,389.02818h0a2.97763,2.97763,0,0,1,4.1087-.92264l0,0,37.73505,23.89567A2.97766,2.97766,0,0,1,748.883,416.11h0L706.1166,389.0282Z",
    transform: "translate(-233.2585 -177.1545)",
    fill: "#ff9100"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M702.54847,390.29209l1.18717-1.87472a2.03479,2.03479,0,0,1,2.80771-.63048h0l42.96453,27.20725a2.40994,2.40994,0,0,1,.74671,3.32533l-.98648,1.55779h0l-46.71964-29.58517Z",
    transform: "translate(-233.2585 -177.1545)",
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 709.72985,
    y: 390.89006,
    width: 0.85077,
    height: 3.40302,
    transform: "translate(-234.71873 605.37556) rotate(-57.656)",
    fill: "#d0cde1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 713.68304,
    y: 393.39341,
    width: 0.85077,
    height: 3.40302,
    transform: "translate(-234.99546 609.87947) rotate(-57.656)",
    fill: "#d0cde1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M742.93542,399.82172a10.52665,10.52665,0,0,1,1.30641,1.02009L792.417,389.06715l3.39291-11.56039,18.11595,2.84019-4.01761,21.04913a8,8,0,0,1-7.099,6.464l-56.167,5.35377a10.4971,10.4971,0,1,1-3.7068-13.39216Z",
    transform: "translate(-233.2585 -177.1545)",
    fill: "#9e616a"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M790.95716,386.67735a4.49514,4.49514,0,0,1-.45149-3.71976l6.86707-40.51618a12.49741,12.49741,0,0,1,24.68067,3.94985l-.3296,41.6563a4.5,4.5,0,0,1-5.22362,4.37561l-22.43134-3.65732A4.49491,4.49491,0,0,1,790.95716,386.67735Z",
    transform: "translate(-233.2585 -177.1545)",
    fill: "#ff9100"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M800.55347,253.56818h-.00006a28.36116,28.36116,0,0,0-14.55909,4h-1.94091a27,27,0,0,0-27,27h15v32h57v-34.5A28.5,28.5,0,0,0,800.55347,253.56818Z",
    transform: "translate(-233.2585 -177.1545)",
    fill: "#2f2e41"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M965.55081,722.8455H550.2568a1.19069,1.19069,0,1,1,0-2.38137h415.294a1.19069,1.19069,0,1,1,0,2.38137Z",
    transform: "translate(-233.2585 -177.1545)",
    fill: "#cacaca"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.657b99e13c1f1bf2a47bac12b9cc4618.svg";
export { ForwardRef as ReactComponent };